// Auto-generated by `rake web:generate`. Do not edit manually.
export const GENERATED_MEMORY_DUMP_ASSET_FILES = Object.freeze([
  "./assets/fixtures/apple2/memory/karateka_mem.bin",
  "./assets/fixtures/apple2/memory/karateka_mem.rhdlsnap",
  "./assets/fixtures/cpu/software/conway_glider_80x24.bin",
  "./assets/fixtures/cpu/software/mandelbrot_80x24.bin",
  "./assets/fixtures/cpu/software/print_hash_top_left.bin",
  "./assets/fixtures/cpu/software/print_x_row10_col10.bin",
  "./assets/fixtures/gameboy/roms/dmg_boot.bin",
  "./assets/fixtures/mos6502/memory/karateka_mem.bin",
  "./assets/fixtures/mos6502/memory/karateka_mem.rhdlsnap",
  "./assets/fixtures/riscv/software/bin/linux_bootstrap.bin",
  "./assets/fixtures/riscv/software/bin/linux_kernel.bin",
  "./assets/fixtures/riscv/software/bin/xv6_kernel.bin"
]);
